export default "__VITE_ASSET__C3HZLKh4__"